<template>
    <b-standard-card
        title="API Token"
        height="auto"
        class="mt-5"  
        :infoMessage="copiedTxt"
        hideDefaultFooter
    >
        <v-row @click="copyKey" no-gutters justify="center" class="copyKey">
            <v-col cols="11" >
                <b-text-field
                    no-top-margin
                    v-model="public_api_token"
                    disabled
                    append-icon="mdiContentCopy"
                ></b-text-field>
            </v-col>
        </v-row>
         <v-row no-gutters justify="center" >
            <v-col cols="11" >
               <span> {{ translations.linkText[lang] + ' ' }} <a :href="docsUrl" target="_blank">{{ docsUrl }} </a></span>
            </v-col>
        </v-row>
    </b-standard-card>
</template>

<script>
import { mapState,mapGetters, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/businessProfile/apiToken";

export default {
    name: "ApiToken",
    mixins: [translations],

    data() {
        return {
            public_api_token: '',
            copiedTxt: null,
            docsUrl: 'https://roadcubepublicapi.docs.apiary.io/#'
        }
    },

     methods:{

         getApiToken(){
             let apiToken = this.$store.state.loyaltyPanel.public_api_token;
            //  let apiToken = 'this.$store.state.loyaltyPanel.public_api_token';
             this.public_api_token = apiToken
         },

        copyKey(){
            let copyDone = {
                en: 'Copied to clipboard!',
                el: 'Αντιγράφηκε!',
                it: 'Copiato'
            }
            navigator.clipboard.writeText(this.public_api_token);
            this.copiedTxt = this.public_api_token && copyDone[this.lang]
             setTimeout(() =>  this.copiedTxt = null, 1500);
        },

        getPermission(path) {
          return this.superUser || (
              eval("this.permissions.developers.api_keys." + path) &&
              eval("this.storePermissions.developers.api_keys." + path)
          );
        },
    },
    
    computed: {
        
        ...mapState([
            "loading",
            "errorMessage",
            "superUser",
            "panelType",
            "permissions",
            "storePermissions"
        ]),


        lang() {
            return this.$route.params.lang;
        },

    },
    watch:{
        ["$store.state.loyaltyPanel.public_api_token"]: {
            handler(val) {
                this.public_api_token = val
            }
        },
    },
    mounted() {
        this.getApiToken();
    }

};
</script>
<style scoped>
.copyKey:hover {
    cursor: copy
}
</style>

<style>
.copyKey input {
    color: black !important;
}
</style>